import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

const CREDIT_CARD_WIDTH = 85.6;
const CREDIT_CARD_HEIGHT = 53.98;

export default function Calibrate() {

  const navigate = useNavigate();
  const canvasRef = useRef(null);

  const [cardWidthPx, setCardWidthPx] = useState(300);

  // 🔥 DRAW
  const draw = () => {

    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // background
    ctx.fillStyle = "#f8f9fb";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const aspectRatio = CREDIT_CARD_WIDTH / CREDIT_CARD_HEIGHT;
    const cardHeightPx = cardWidthPx / aspectRatio;

    const x = (canvas.width - cardWidthPx) / 2;
    const y = (canvas.height - cardHeightPx) / 2;

    // 🔥 card border
    ctx.strokeStyle = "#222";
    ctx.lineWidth = 2;
    ctx.strokeRect(x, y, cardWidthPx, cardHeightPx);

    // 🔥 corner indicator
    ctx.fillStyle = "#999";
    ctx.beginPath();
    ctx.moveTo(x + cardWidthPx - 20, y + cardHeightPx);
    ctx.lineTo(x + cardWidthPx, y + cardHeightPx - 20);
    ctx.lineTo(x + cardWidthPx, y + cardHeightPx);
    ctx.closePath();
    ctx.fill();
  };

  useEffect(() => {
    draw();
  }, [cardWidthPx]);

  // 🔥 SLIDER CHANGE
  const handleSlider = (e) => {
    setCardWidthPx(Number(e.target.value));
  };

  // 🔥 SAVE
  const handleStore = () => {

    const pixelsPerMm = cardWidthPx / CREDIT_CARD_WIDTH;

    localStorage.setItem("pixel_in_mm", pixelsPerMm);

    navigate("/anticipation/play");
  };

  return (
    <div style={{ maxWidth: 900, margin: "40px auto", textAlign: "center" }}>

      <h2 style={{ fontSize: 28, marginBottom: 20 }}>
        📏 Screen Calibration
      </h2>

      {/* CANVAS */}
      <canvas
        ref={canvasRef}
        width={900}
        height={400}
        style={{
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: 10,
          marginBottom: 30
        }}
      />

      {/* STEPS */}
      <p style={{ fontSize: 16 }}>
        Step 1: Place the Credit Card in the box
      </p>

      <p style={{ fontSize: 16, marginTop: 10 }}>
        Step 2: Adjust size using slider
      </p>

      {/* SLIDER */}
      <input
        type="range"
        min="200"
        max="600"
        value={cardWidthPx}
        onChange={handleSlider}
        style={{
          width: "80%",
          marginTop: 15,
          marginBottom: 20
        }}
      />

      <p style={{ fontSize: 16 }}>
        Step 3: Click continue when matched
      </p>

      {/* BUTTON */}
      <button
        onClick={handleStore}
        style={{
          background: "#1e1b4b",
          color: "#fff",
          padding: "10px 25px",
          borderRadius: 8,
          border: "none",
          marginTop: 15,
          cursor: "pointer"
        }}
      >
        Continue
      </button>

    </div>
  );
}